/* Iris the Brand — Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  // Scroll reveal
  var ro = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function (el) { ro.observe(el); });

  // Nav dropdowns
  document.querySelectorAll('.nav-dropdown-trigger').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var key = this.dataset.dropdown;
      var dd = document.getElementById('dropdown-' + key);
      var isOpen = dd && dd.classList.contains('open');
      // close all
      document.querySelectorAll('.nav-dropdown').forEach(function (d) { d.classList.remove('open'); });
      document.querySelectorAll('.nav-dropdown-trigger').forEach(function (b) { b.classList.remove('open'); });
      if (!isOpen && dd) { dd.classList.add('open'); this.classList.add('open'); }
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.nav-dropdown').forEach(function (d) { d.classList.remove('open'); });
    document.querySelectorAll('.nav-dropdown-trigger').forEach(function (b) { b.classList.remove('open'); });
  });

  // Hamburger / mobile menu
  var ham = document.getElementById('hamburger');
  var mob = document.getElementById('mobile-menu');
  if (ham && mob) {
    ham.addEventListener('click', function () {
      ham.classList.toggle('open');
      mob.classList.toggle('open');
      document.body.style.overflow = mob.classList.contains('open') ? 'hidden' : '';
    });
  }

  // Product gallery thumbnails
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.querySelector('.product-gallery-main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        var src = this.querySelector('img') ? this.querySelector('img').src : null;
        if (src) mainImg.src = src;
      });
    });
    if (thumbs[0]) thumbs[0].classList.add('active');
  }

  // Cart quantity buttons
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.closest('.cart-item-qty-wrap').querySelector('.qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus') val = Math.max(0, val - 1);
      else val = val + 1;
      input.value = val;
    });
  });

});
